export default {
  landing: '/',
  getStarted: '/getStarted',
  signUp: '/signUp',
  login: '/login',
  privacyPolicy: '/privacy',
  tos: '/tos',
  about: '/about',
  contact: '/contact',
  store: '/store',
  team: '/team',
  help: '/help',
  research: '/research',
  shop: '/shop',
  paymentSuccess: '/paymentSuccess',
  paymentCanceled: '/paymentCanceled',
};
